import { render, staticRenderFns } from "./AssemblyUpdate.vue?vue&type=template&id=31190cc2"
import script from "./AssemblyUpdate.vue?vue&type=script&lang=js"
export * from "./AssemblyUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports